import Spinner from "react-bootstrap/Spinner";

function GrowExample() {
  return (
    <div className="spinner-container">
      <Spinner animation="grow" />
    </div>
  );
}

export default GrowExample;
